import { render } from "./RequestSharesComponent.vue?vue&type=template&id=66b75890&ts=true"
import script from "./RequestSharesComponent.vue?vue&type=script&lang=ts"
export * from "./RequestSharesComponent.vue?vue&type=script&lang=ts"

import "./RequestSharesComponent.vue?vue&type=style&index=0&id=66b75890&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__